"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStringListParam = exports.getParsedSearchParams = exports.defaultOptions = exports.stringifyOption = void 0;

var tslib_1 = require("tslib");

var qs_1 = require("qs");

var isString_1 = tslib_1.__importDefault(require("lodash-es/isString"));

exports.stringifyOption = {
  encodeValuesOnly: true,
  skipNulls: true,
  arrayFormat: 'brackets',
  addQueryPrefix: true
};
exports.defaultOptions = {
  comma: true,
  ignoreQueryPrefix: true
};

function getParsedSearchParams(parameter) {
  var _ref = parameter || {},
      search = _ref.search,
      parseOptions = _ref.parseOptions;

  var searchString = search !== null && search !== void 0 ? search : window.location.search;
  return qs_1.parse(searchString, Object.assign(Object.assign({}, exports.defaultOptions), parseOptions));
}

exports.getParsedSearchParams = getParsedSearchParams;

function getStringListParam(value) {
  if (!Array.isArray(value)) {
    return [];
  }

  if (value.length && !value.some(function (v) {
    return !isString_1.default(v);
  })) {
    return value;
  }

  return [];
}

exports.getStringListParam = getStringListParam;